import { Component, HostListener, inject, signal, Type, ViewChild, ViewContainerRef, WritableSignal } from '@angular/core'
import { DialogService, IDialogParameters } from './dialog.service'

@Component({
    selector: 'dialog-modal',
    templateUrl: 'dialog-modal.component.html',
    styleUrls: ['dialog-modal.component.scss'],
})
export class DialogModalComponent {
    public parameters: WritableSignal<IDialogParameters | undefined> = signal(undefined)
    public classApplied = signal(false)

    #dialogService = inject(DialogService)

    @ViewChild('contentAnchor', { read: ViewContainerRef })
    contentAnchor!: ViewContainerRef

    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            event.preventDefault()
            if (this.parameters()?.closeOnEscapeKey !== false) {
                this.#dialogService.close()
            }
        }
    }

    loadContent(componentType: Type<any>) {
        if (!this.contentAnchor) return
        this.contentAnchor.clear()
        this.contentAnchor.createComponent(componentType)
    }

    onBackdropClick() {
        if (this.parameters()?.closeOnBackdropClick !== false) {
            this.#dialogService.close()
        }
    }

    close() {
        this.#dialogService.close()
    }
}
